<template>
  <router-view />
</template>

<script>
export default {
  name: 'UserExpress',
}
</script>
